import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Li, B, DivLink, DivIconContainer, IIcon, DivTitle } from '../style';
var SidebarLink = function (_a) {
    var to = _a.to, icon = _a.icon, title = _a.title, primary = _a.primary, secondary = _a.secondary;
    var pathname = useLocation().pathname;
    return (React.createElement(Li, { active: pathname === to, primaryColor: primary, secondaryColor: secondary },
        React.createElement(B, { active: pathname === to, primaryColor: primary, secondaryColor: secondary }),
        React.createElement(B, { active: pathname === to, primaryColor: primary, secondaryColor: secondary }),
        React.createElement(Link, { to: to },
            React.createElement(DivLink, { active: pathname === to, primaryColor: primary, secondaryColor: secondary },
                React.createElement(DivIconContainer, null, typeof icon === 'string' ? React.createElement(IIcon, { className: icon }) : icon),
                React.createElement(DivTitle, null, title)))));
};
export default SidebarLink;
